const getArabicPostType = postType => {
    if (postType === "article") return "case study"
    else if (postType === "news-article") return "خبر"
    else if (postType === "story") return "قصة"
    else if (postType === "review") return "مراجعة"
    else if (postType === "how-to") return "كيف"
    else if (postType === "video") return "فيديو"
}

export default getArabicPostType